import { ArrayMinSize, IsArray, IsObject, ValidateNested } from 'class-validator';

import { CartAuctionUpdateFinishModel } from './cartAuctionUpdateFinish.model';
import { CartUpdateFinishModel } from './cartUpdateFinish.model';

export class CartFinishModel {
  @IsObject()
  @ValidateNested()
  public cart: CartUpdateFinishModel;

  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  public auctions: CartAuctionUpdateFinishModel[];

  constructor(
    cart: CartUpdateFinishModel,
    auctions: CartAuctionUpdateFinishModel[]
  ) {
    this.cart = cart;
    this.auctions = auctions;
  }
}
